import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import App from "./App.vue";
import router from "./plugins/router";
import store from "./store";
import i18n from "./plugins/i18n";
import MessagePlugin from "./plugins/message/message";
import Axios from "./api/axios";
import moment from 'moment'

import "./styles.scss";

import locale from "element-ui/lib/locale/lang/zh-TW";
Vue.use(ElementUI, {
  locale
});

Vue.prototype.$moment = moment;
Vue.use(Axios, {});

Vue.use(MessagePlugin, {
  i18n
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");